module.exports = __webpack_public_path__ + "img/xcxD.de63b68.png";